import { Person } from "../action-co/action-co.model";
import { BlockTree } from "../blocked";
import { BObjectModel } from "../bodisplay/bodisplay.model";
import { QueovalDate, QueovalDateTime } from "../global";

export class FilterPlanning {
  public DateDebut: QueovalDate;
  public DateFin: QueovalDate;
  public Formateurs: Array<Person>;
  public ShowOnlyNew: boolean;
  public IndeterminateSelect: boolean = false;
}

export class ReservationPlanningAndIdStage {
  public IdStage: string;
  public reservations: Array<ReservationPlanning>;
}

export class ReservationPlanning {
  public Ident: string;
  public DateDebut: QueovalDateTime;
  public DateFin: QueovalDateTime;
  public Formateurs: Array<Person>;
  public Titre: string;
  public Duree: string;
  public ObjetReserves: BlockTree;
/*  public IsNewReserv: boolean;*/
  public IsSelected: boolean;
  // Type de réservation : Matin / Aprem / Journée... 
  public TypeReserv: string;
  public BoReserv: BObjectModel;

  public IsSynchroSWS: boolean;

  public JourSemaine: string;
  public ShortDate: string;
  public ShortDateEnd: string

  public IdLieu: string;
  public IdBureau: string;

  public CodeDispo: string;
  public HasZoom: boolean;
  // #region Suivi des présences
  public GridName: string;
  /**
   * Nombre "non affecté"
   */
  public NbNa: number;
  /**
    * Nombre "présents"
    */
  public NbPresent: number;
  /**
   * Nombre "Absents"
   */
  public NbAbs: number;
  /**
   * Nombre "Absences injustifiées"
   */
  public NbAbsInj: number;
  /**
   * Nombre "Préinscrits"
   */
  public NbPreinsc: number;
  /**
   * Etat en fonction des personnes affectés
   */
  public Etat: EtatPresence;
  // #endregion

  public IsEdit: boolean;

  public Conflits: Array<ConflitsReservations>;
}

export class ConflitsReservations {
  public IdentResa: string;
  public NomItem: string;
  public NomResa: string;
  public DateDebutResa: QueovalDateTime;
  public DateFinResa: QueovalDateTime;
}

export class ReservationForUpdate extends ReservationPlanning {
  public ShowTrainer: boolean;
  public ShowObject: boolean;
  public ShowLocation: boolean;
  public ShowOffice: boolean;
  public ShowDispo: boolean;
}

export class CreationReservationModel {
  /** Dates intervalle sélectionnée dans le planning */
  public DateDebut: QueovalDate;

  /** Dates intervalle sélectionnée dans le planning */
  public DateFin: QueovalDate;
  public Modes: Array<string>;
  public Days: Array<string>;
  public Formateurs: Array<Person>;
  public ObjetReserves: BlockTree;
  public model: BObjectModel;
  public AMFrom: string = '';
  public AMTo: string = '';
  public AMDuration: string = '';

  public PMFrom: string = '';
  public PMTo: string = '';
  public PMDuration: string = '';

  public DayDuration: string;
  public RangeDuration: string = '';
  public StageIdent: string;

  public IdLieu: string;
  public IdBureau: string;
  public CodeDispo: string;
}

/**
 * Modèle spécifique à l'enregistrement d'un lien "présence" d'un apprenant sur une réservation
 **/
export class LearnerPresence {
  public IdReserv: string[];
  public IdLearner: string;
  public IdStage: string;
  public IdRelation?: string;
  public CodePresence: string;
}

export enum EtatPresence {
  OK,
  PARTIAL,
  NONE,
}

export enum PlanningOnglet {
  Planning,
  SuiviPresence,
  ReservBureau,
}
